import { useRef, useInsertionEffect, useCallback } from 'react'

// The useEvent API has not yet been added to React,
// so this is a temporary shim to make this sandbox work.
// You're not expected to write code like this yourself.

export function useEvent<T extends (...args: any[]) => any>(
  fn: T | null | undefined,
): (...args: Parameters<T>) => ReturnType<T> | undefined {
  const ref = useRef<T | null | undefined>(null)
  useInsertionEffect(() => {
    ref.current = fn
  }, [fn])
  return useCallback((...args: Parameters<T>) => {
    const f = ref.current
    return f?.(...args) as ReturnType<T> | undefined
  }, [])
}
